import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
const state = () => ({
	payloadData: {},
	storeTestID: {},
});

// getters
const getters = {
	getPayloadData: (state) => state.payloadData,
	getStoreTestID: (state) => state.storeTestID,
};

//actions
const actions = {};

// mutations
const mutations = {
	setPayloadData(state, payload) {
		state.payloadData = payload;
	},
	setStoreTestID(state, payload) {
		state.storeTestID = payload;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
